(function(angular) {
    'use strict';

    angular.module('aprima-facility-api').factory('FacilityPatientRepository', [
        'AprimaAnalytics',
        'AprimaRestangular',
        FacilityPatientRepository
    ]);

    function FacilityPatientRepository(
        AprimaAnalytics,
        AprimaRestangular
    ) {
        return {
            getPatients: getPatients,
        };

        function getPatients(searchCriteria){
            var timing = AprimaAnalytics.startTiming('FacilityPatientRepository', 'api', 'getPatients');
            var restangular = AprimaRestangular.get('facility');
            return restangular.one('patients')
                              .get(searchCriteria)
                              .finally(timing.stop);
        }
    }
})(window.angular);